<template>
  <div class="shipmentReport">
    <div class="tabbar">
      <left theme="filled" style="font-size: 20px; margin: 6px 16px 0 24px; float: left" @click="$router.back()" />
      <div class="add_title">{{ h_i18n('ec006c91b72265f9e0381115b71dfe72') }}</div>
      <div class="add_import_title" v-show="flag == 'add'">{{ h_i18n('c6848f26de2d97b7f5a656035edbb4bb') }}</div>
      <div class="btn_gro">
        <div class="item_btn" style="width: 88px" v-show="flag == 'add'" @click="exportmuban()">{{ h_i18n('f448ce54de4486f3af400142a8ee2602') }}</div>
        <div class="item_btn" style="width: 88px" v-show="flag == 'add'" @click="Importmuban()">{{ h_i18n('ffe13456005d72e16a2f282120d72a41') }}</div>
        <div class="item_btn" @click="$router.back()">{{ h_i18n('625fb26b4b3340f7872b411f401e754c') }}</div>
        <div class="item_btn" style="color: #165dff; border: #165dff 1px solid" v-if="saveTempFlag" @click="saveTemp">{{ h_i18n('d8acae3bcfbc9ec9ade58c2dbacf65aa') }}</div>
        <div class="item_btn" style="background: #165dff; color: #fff" v-if="flag == 'edit' || flag == 'add'"
          @click="submit()">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</div>
        <div class="item_btn" style="background: #165dff; color: #fff" v-if="flag == 'audit'" @click="audit('2')">{{ h_i18n('e61f2cc4c39244f627b20e18788c3890') }}</div>
        <div class="item_btn" v-if="flag == 'audit'" @click="audit('3')">{{ h_i18n('1bf19c1953d1351b341497c74715e83c') }}</div>
      </div>
    </div>
    <div class="fac_nav">
      <div class="fac_flex fac_bg">
        <img src="@/assets/img/Haier-logo.png" />
        <span class="nav_title">{{ h_i18n('515ddeee81af7132f758a3c4a18f1cef') }}</span>
        <div>
          <span style="color: #4e5969">{{ h_i18n('642ab685aba1536a43228fea4ac9e11b') }}</span>
          {{ materData.reportNo }}
        </div>
      </div>
      <div class="fac_flex fac_mes">
        <div><span style="color: #4e5969">{{ h_i18n('7c7fefb36371a5a9ab5338c98790c67c') }}</span>{{ materData.mtlNo }}</div>
        <div><span style="color: #4e5969">{{ h_i18n('7a0ae7305076f170b4a920ef5f3f04f9') }}</span>{{$route.query.mtlName? $route.query.mtlName : materData.mtlName }}</div>
        <div>
          <span style="color: #4e5969">{{ h_i18n('eb0e130294c8c3b3fa2cfecc849fec49') }}</span>{{ materData.supplyName }}
        </div>
        <div>
          <span style="color: #4e5969">{{ h_i18n('15be0cbf984ead7733f52bbd01db11a2') }}</span>{{ materData.supplyCode }}
        </div>
      </div>
    </div>
    <div class="fac_inp">
      <div class="fac_inp_title">{{ h_i18n('0a88ad9805ed9bffd9e36d6302f74058') }}</div>
      <div class="fac_flex">
        <div class="fac_33">
          <div style="color: #4e5969">{{ h_i18n('ab9171823cf0ff877181376ae3cefe11') }}</div>
          <el-input :disabled="editFalg" v-model="materData.supplyBacth" :placeholder="h_i18n('ab9171823cf0ff877181376ae3cefe11')" style="width: 280px" />
        </div>
        <div class="fac_33">
          <div style="color: #4e5969">{{ h_i18n('4b2f8dbe99855fdbcae45945efe19c82') }}</div>
          <el-input :disabled="editFalg" v-model="materData.bacthLine" :placeholder="h_i18n('4b2f8dbe99855fdbcae45945efe19c82')" style="width: 280px" />
        </div>
        <div class="fac_33">
          <div style="color: #4e5969">{{ h_i18n('45874c85767113619ab5e110b87c69ab') }}</div>
          <el-date-picker :disabled-date="disabledDate" style="width: 280px" :disabled="editFalg" type="date"
            @change="changeFun" v-model="materData.bacthProductDate" :placeholder="h_i18n('4ff1e74e43a3586339251494117185ad')"></el-date-picker>
        </div>
      </div>
      <div class="fac_flex">
        <div class="fac_33">
          <div style="color: #4e5969">{{ h_i18n('659d36500f21014ae4360729013f1fcc') }}</div>
          <el-input :disabled="editFalg" style="width: 280px" :placeholder="h_i18n('659d36500f21014ae4360729013f1fcc')" v-model="materData.shiftProduct" />
        </div>
        <div class="fac_33" v-if="notEyeFlag">
          <div style="color: #4e5969">{{ h_i18n('4bc70779dfcf23aefffe0e4175e410fb') }}</div>
          <el-select :disabled="editFalg" style="width: 280px" v-model="materData.factoryAddress" allow-create
          filterable :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')">
          <el-option v-for="item in supplyCodeList" :key="item.factoryAdress" :label="item.factoryAdress"
          :value="item.factoryAdress">
        </el-option>
      </el-select>
      <!-- ①非天眼供应商生产地址增加备注“地址应和海达源认证通过产地一致,如不一致请联系Haier采购资源更新 产地管理”，产地管理 为超链接样式跳转“过程检测-产地管理”； -->
      <span class="tipBox_yellow">
        <img src="@/assets/img/tips-icon.png" class="tip-img" />
        <span>{{ h_i18n('544F8D0A3833A90FF764B00B3A7F6B05') }} &nbsp;
          <!-- 产地管理 -->
        <span class="blueClick" @click="navigateTo()">{{h_i18n('2A4618C5951EE4383C7CC4E1684B3E67')}}</span></span>
      </span>
        </div>
        <div class="fac_33">
          <div style="color: #4e5969">{{ h_i18n('4088b9452f5cc640696039f845b2b2a1') }}</div>
          <el-input :disabled="editFalg" style="width: 280px" v-model="materData.bacthNum" :placeholder="h_i18n('4088b9452f5cc640696039f845b2b2a1')" />
        </div>
      </div>
    </div>
    <div class="fac_photo" v-if="!notEyeFlag">
      <InspectPhoto v-if="!notEyeFlag" @shipmentfactoryevent="getImageAndFAddress" @deleteImg="deletePhoto"
        :paramsData="paramsData" :starFlag="starFlag" @saveOfFacImgTemp="saveTemp" @changeFunEmit="changeFun"
        @changeRouter="changeRouter" :zeroFlag="zeroFlag">
      </InspectPhoto>
    </div>
    <div class="fac_table_wrap">

      <div style="color: #f53f3f;font-weight: 900;margin-bottom: 10px;display: flex;width: 100%;font-size: 16px;background-color: #FFF7E8;outline: 1px solid #FFE4BA;padding: 10px;box-sizing: border-box;border-radius: 7px;">
        <div>1、样本大小、AC、RE 只能填数字或/，不能填字母或符号 2、实测值 不允许填写表情符号，比如 🆗 🔶 💙 </div>
      </div>
    <div class="fac_table">
      <div class="fac_tr" style="height: 40px;background:rgb(241, 242, 248);text-align:center;line-height:40px;border-radius: 8px 8px 0 0 ;">
        <div class="fac_table_50">{{ h_i18n('faaadc447b1c2b1adc920d9c9aedcc25') }}</div>
        <div class="fac_table_150">{{ h_i18n('222c0f1a6341c9df01ca58fc982db93b') }}</div>
        <!-- 技术（标准）要求 -->
        <div class="fac_table_max">{{ h_i18n('afb44627fabcf435b4633f1f6bd12eb3') }}</div>
        <div class="fac_table_100">{{ h_i18n('4626e7457839719f5fa1b08526e5e3fd') }}</div>
        <div class="fac_table_100">{{ h_i18n('0cf684d33849528278363c0e3991cb82') }}</div>
        <div class="fac_table_100">AQL</div>
        <div class="fac_table_100">{{ h_i18n('9e23b61ce24cfada6fea1cdc2277976c') }}</div>
        <div class="fac_table_200">
          <div style="width: 100%;height:50%;line-height:20px">{{ h_i18n('9ad6f829b961e347a0c8233ea1e57e42') }}</div>
          <div style="width: 100%;height:50%;display:flex;text-align:center;line-height:20px">
            <div style="width: 50%;">AC</div>
            <div style="width: 50%;">RE</div>
          </div>
        </div>
        <div class="fac_table_300">{{ h_i18n('c5fb490f9763ca6e6320049b20e23a92') }}</div>
        <div class="fac_table_100">{{ h_i18n('4158228943415a8cc85084d68ef18802') }}</div>
      </div>
      <div v-for="(item, index) in list" :key="index">
        <div class="fac_table_nav">{{ h_i18n('93857b3e7110f600d178883ce9b9bbe5') }}<span style="color: #165DFF;margin:0 56px 0 12px">{{ item.templateCode
            }}</span>{{ h_i18n('815c8383e4d0e5642f8856a49e752c73') }}<span style="color: #165DFF;margin-left:12px">{{ item.templateName }}</span>
        </div>
        <div v-for="(child, childIndex) in item.itemList" :key="child.itemId" class="fac_tr">
          <div class="fac_table_50 fac_center">{{ childIndex + 1 }}</div>
          <div class="fac_table_150 fac_table_hidden" :title="child.itemName">{{ child.itemName }}</div>
          <div class="fac_table_max fac_table_hidden" :title="child.remark">{{ child.remark }}</div>
          <div class="fac_table_100">
            <el-select disabled v-if="child.importanceProperty != null" v-model="child.importanceProperty"
              :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" @change="changeFun">
              <el-option v-for="optionKey in importancePropertyList" :key="optionKey.valueId + ''"
                :label="optionKey.valueName" :value="optionKey.valueId + ''"></el-option>
            </el-select>
            <el-select disabled v-else v-model="child.importancePropertyName" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" @change="changeFun">
              <el-option v-for="optionKey in importancePropertyList" :key="optionKey.importancePropertyName + ''"
                :label="optionKey.valueName" :value="optionKey.valueId + ''"></el-option>
            </el-select>
          </div>
          <div class="fac_table_100">
            <el-select disabled v-if="child.checkLevel != null" v-model="child.checkLevel" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')"
              @change="changeFun">
              <el-option v-for="optionKey in checkLevelList" :key="optionKey.valueId + ''" :label="optionKey.valueName"
                :value="optionKey.valueId + ''"></el-option>
            </el-select>
            <el-select disabled v-else v-model="child.checkLevelName" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" @change="changeFun">
              <el-option :label="child.checkLevelName" :value="child.checkLevelName">
                {{ child.checkLevelName }}
              </el-option>
            </el-select>
          </div>

          <div class="fac_table_100">
            <el-input :disabled="true" v-model="child.aqlProperty" />
          </div>
          <div class="fac_table_100">
            <el-input :disabled="editFalg" v-model="child.sampleNum" placeholder="" />
          </div>
          <div class="fac_table_100">
            <el-input :disabled="editFalg" v-model="child.ac" placeholder="" />
          </div>
          <div class="fac_table_100">
            <el-input :disabled="editFalg" v-model="child.re" placeholder="" />
          </div>
          <div class="fac_table_300">
            <el-input v-if="!editFalg" v-model="child.measured" :rows="1" type="textarea" maxlength="1500" placeholder="" />
            <span v-else :title="child.measured" style="
                float: left;
                text-align: left;
                padding: 5px;
                max-width: 290px;
              ">{{ child.measured }}</span>
          </div>
          <div class="fac_table_100">
            <!-- <el-input v-model="child.child5" placeholder="请输入内容"/> -->
            <el-select :disabled="editFalg" v-model="child.voteResult" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" @change="changeFun"
              :item="child.voteResult ? '' : (child.voteResult = '合格')">
              <el-option :key="h_i18n('86f720320b77bb62311f0a4811db04fe')" :label="h_i18n('86f720320b77bb62311f0a4811db04fe')" value="合格"></el-option>
              <el-option :key="h_i18n('6e5a122013138ad189517d5d0a1c0891')" :label="h_i18n('6e5a122013138ad189517d5d0a1c0891')" value="不合格"></el-option>
              <el-option :key="h_i18n('321ff794aab8c6cd671990a98ef212a0')" :label="h_i18n('321ff794aab8c6cd671990a98ef212a0')" value="不适用"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div v-for="(item, index) in commentList" :key="item.templateName + index">
        <div class="fac_table_nav"><span style="color:  #165DFF;;">{{ item.templateName }}</span></div>
        <div v-for="(child, childIndex) in item.itemList" :key="child.itemId">
          <div class="fac_tr" v-if="!(child.itemName == '有害物质' || child.itemName == '认证情况')">
            <div class="fac_table_50 fac_center">{{ childIndex + 1 }}</div>
            <div class="fac_table_150 fac_table_hidden" :title="child.itemName">{{ child.itemName }}</div>
            <div class="fac_table_max fac_table_hidden" :title="child.remark">{{ child.remark }}</div>
            <div class="fac_table_100">
              <!-- {{child.importanceProperty}} -->
              <el-select disabled v-if="child.importanceProperty" v-model="child.importanceProperty" @change="changeFun"
                :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')">
                <el-option v-for="optionKey in importancePropertyList" :key="optionKey.valueId + ''"
                  :label="optionKey.valueName" :value="optionKey.valueId + ''"></el-option>
              </el-select>
              <el-select disabled v-else v-model="child.importancePropertyName" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" @change="changeFun">
                <el-option v-for="optionKey in importancePropertyList" :key="optionKey.valueId + ''"
                  :label="optionKey.importancePropertyName" :value="optionKey.valueId + ''"></el-option>
              </el-select>
            </div>
            <div class="fac_table_100">
              <!-- {{child.checkLevel}} -->
              <el-select disabled v-if="child.checkLevel" v-model="child.checkLevel" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')"
                @change="changeFun">
                <el-option v-for="optionKey in checkLevelList" :key="optionKey.valueId + ''"
                  :label="optionKey.valueName" :value="optionKey.valueId + ''"></el-option>
              </el-select>
              <el-select disabled v-else v-model="child.checkLevelName" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" @change="changeFun">
                <el-option v-for="optionKey in checkLevelList" :key="optionKey.valueId + ''"
                  :label="optionKey.checkLevelName" :value="optionKey.valueId + ''"></el-option>
              </el-select>
            </div>

            <div class="fac_table_100">
              <el-input :disabled="true" v-model="child.aqlProperty" />
            </div>
            <div class="fac_table_100">
              <el-input :disabled="editFalg" v-model="child.sampleNum" placeholder="" />
            </div>
            <div class="fac_table_100">
              <el-input :disabled="editFalg" v-model="child.ac" placeholder="" />
            </div>
            <div class="fac_table_100">
              <el-input :disabled="editFalg" v-model="child.re" placeholder="" />
            </div>
            <div class="fac_table_300">
              <el-input v-if="!editFalg" v-model="child.measured" :rows="1" type="textarea" placeholder="" />
              <span v-else  :title="child.measured" style="float: left; text-align: left; padding: 5px;max-width: 290px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{
                child.measured
              }}</span>
            </div>
            <div class="fac_table_100">
              <el-select :item="child.voteResult ? '' : (child.voteResult = '合格')" v-model="child.voteResult"
                @change="changeFun" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" :disabled="editFalg">
                <el-option :key="h_i18n('86f720320b77bb62311f0a4811db04fe')" :label="h_i18n('86f720320b77bb62311f0a4811db04fe')" value="合格"></el-option>
                <el-option :key="h_i18n('6e5a122013138ad189517d5d0a1c0891')" :label="h_i18n('6e5a122013138ad189517d5d0a1c0891')" value="不合格"></el-option>
                <el-option :key="h_i18n('321ff794aab8c6cd671990a98ef212a0')" :label="h_i18n('321ff794aab8c6cd671990a98ef212a0')" value="不适用"></el-option>
              </el-select>
            </div>
          </div>
          <div v-if="child.itemName == '认证情况'" class="fac_tr">
            <div class="fac_table_50 fac_center">{{ childIndex + 1 }}</div>
            <div class="fac_table_150 fac_table_hidden" :title="child.itemName">{{ child.itemName }}</div>
            <div class="fac_table_max2 fac_table_hidden" :title="child.remark">{{ child.remark }}</div>
            <div style="width: 200px;" class="marginAuto">
              <el-input v-if="!editFalg" v-model="materData.authName" :rows="1" :placeholder="h_i18n('22893ee4487d6e0ff5e2fd2b44c71ed4')" />
              <span v-else class="fac_table_hidden" style="
                  float: left;
                  text-align: left;
                  padding: 5px;
                  word-break: break-all;
                ">{{ materData.authName }}</span>
            </div>
            <div style="width: 200px;" class="marginAuto">
              <el-input v-if="!editFalg" v-model="materData.authNo" :rows="1" :placeholder="h_i18n('b48824f6eab57bc677c1e7e75be24f5d')" />
              <span v-else class="fac_table_hidden" style="
                  float: left;
                  text-align: left;
                  padding: 5px;
                  word-break: break-all;
                ">{{ materData.authNo }}</span>
            </div>
            <div style="width: 200px;" class="marginAuto">
              <el-input :disabled="editFalg" v-model="materData.authDate" :placeholder="h_i18n('89984a8de5128063debc839f3c66bbf6')" />
            </div>
            <div class="fac_table_100">
              <el-select :item="child.voteResult ? '' : (child.voteResult = '合格')" :disabled="editFalg"
                @change="changeFun" v-model="child.voteResult" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')">
                <el-option :key="h_i18n('86f720320b77bb62311f0a4811db04fe')" :label="h_i18n('86f720320b77bb62311f0a4811db04fe')" value="合格"></el-option>
                <el-option :key="h_i18n('6e5a122013138ad189517d5d0a1c0891')" :label="h_i18n('6e5a122013138ad189517d5d0a1c0891')" value="不合格"></el-option>
                <el-option :key="h_i18n('321ff794aab8c6cd671990a98ef212a0')" :label="h_i18n('321ff794aab8c6cd671990a98ef212a0')" value="不适用"></el-option>
              </el-select>
            </div>
          </div>
          <div class="fac_tr" v-if="child.itemName == '有害物质'">
            <div class="fac_table_50 fac_center">{{ childIndex + 1 }}</div>
            <div class="fac_table_150 fac_table_hidden" :title="child.itemName">{{ child.itemName }}</div>
            <div class="fac_table_max2 fac_table_hidden" :title="child.remark">{{ child.remark }}</div>
            <div style="width: 400px;" class="marginAuto">
              <el-input :disabled="editFalg || disabledRohsNo" v-model="materData.rohsNo" :placeholder="h_i18n('b04a7f4a058374b8a7a8ff456be98d7a')" />
            </div>
            <div style="width: 200px;" class="marginAuto">
              <el-date-picker :disabled="editFalg || disabledRohsNo" type="date" @change="changeFun" style="width: 190px;"
                v-model="materData.rohsDate" :placeholder="h_i18n('bb114ab9e5de7db0d548194e17b6cc01')"></el-date-picker>
            </div>
            <div class="fac_table_100">
              <el-select :item="disabledRohsNo ? (child.voteResult = '合格') : ''" v-model="child.voteResult"
                @change="changeFun" :disabled="editFalg || disabledRohsNo" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')">
                <el-option :key="h_i18n('86f720320b77bb62311f0a4811db04fe')" :label="h_i18n('86f720320b77bb62311f0a4811db04fe')" value="合格"></el-option>
                <el-option :key="h_i18n('6e5a122013138ad189517d5d0a1c0891')" :label="h_i18n('6e5a122013138ad189517d5d0a1c0891')" value="不合格"></el-option>
                <el-option :key="h_i18n('321ff794aab8c6cd671990a98ef212a0')" :label="h_i18n('321ff794aab8c6cd671990a98ef212a0')" value="不适用"></el-option>
              </el-select>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
      <div class="fac_inp">
        <div class="fac_inp_title">{{ h_i18n('487bb72f29181cf97d58155646ef0b5e') }}</div>
        <div class="fac_flex">
          <div class="fac_33">
            <div style="color: #4e5969">{{ h_i18n('3ba97bd751e79dff382d6ca65e4e3553') }}</div>
            <el-select :disabled="editFalg" style="width: 280px" v-model="materData.checkResult" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" @change="changeFun"
              :item="materData.checkResult ? '' : materData.checkResult = '合格'">
              <el-option :key="h_i18n('86f720320b77bb62311f0a4811db04fe')" :label="h_i18n('86f720320b77bb62311f0a4811db04fe')" value="合格"></el-option>
              <el-option :key="h_i18n('6e5a122013138ad189517d5d0a1c0891')" :label="h_i18n('6e5a122013138ad189517d5d0a1c0891')" value="不合格"></el-option>
              <!-- <el-option key="不适用" label="不适用" value="不适用"></el-option> -->
            </el-select>
          </div>
          <div class="fac_33">
            <div style="color: #4e5969">{{ h_i18n('103d893628df5fb82c0dcc09899bf9d7') }}</div>
            <el-input :disabled="editFalg" style="width: 280px" v-model="materData.checkEmpName" :placeholder="h_i18n('a11cc7a65b27f3993d58438d275f3447')" />
          </div>
          <div class="fac_33">
            <div style="color: #4e5969">{{ h_i18n('1a58c1628876174eab86bc1547134164') }}</div>
            <el-date-picker style="width: 280px" :disabled="editFalg" type="date" v-model="materData.checkDate" :placeholder="h_i18n('1a58c1628876174eab86bc1547134164')"
              @change="changeFun" :disabled-date="disabledDate"></el-date-picker>
          </div>
        </div>
        <div class="fac_flex">
          <div class="fac_33">
            <div style="color: #4e5969">{{ h_i18n('91693713809ffc48fcb8cd5f256bc626') }}</div>
            <el-input disabled  style="width: 280px" v-model="materData.auditEmpName" :placeholder="h_i18n('91693713809ffc48fcb8cd5f256bc626')" />
          </div>
          <div class="fac_33">
            <div style="color: #4e5969">{{ h_i18n('d22bddfcf4bce125d3cc491ec1f2f030') }}</div>
            <el-date-picker disabled style="width: 280px" type="date" v-model="materData.auditDate" @change="changeFun"
              :placeholder="h_i18n('d22bddfcf4bce125d3cc491ec1f2f030')"></el-date-picker>
          </div>
        </div>
      </div>
      <div class="fac_inp" style="height:130px">
        <div class="fac_inp_title">{{ h_i18n('97d7e7ac40b2a31b9cdbde20c724114b') }}</div>
        <div >
          <p class="desc" style="text-indent: 4ch;">{{ h_i18n('c09e45e5b92cd767be3c844cdbd5006b') }}</p>
          <el-checkbox style="text-align: center;width: 100%;" v-model="haseRead" label="1">{{ h_i18n('ee1dfef67afe79135693b84b74f6185e') }}</el-checkbox>
        </div>

      </div>
      <div class="fac_inp" v-show="flag === 'edit'" style="height:130px">
        <div class="fac_inp_title">审核意见</div>
        <el-input type="textarea" style="margin-top: 20px;" disabled v-model="audittextarea">
        </el-input>
      </div>
      <div v-show="flag != 'edit' && flag != 'add'" class="fac_inp" style="height:130px">
        <div class="fac_inp_title">{{ h_i18n('ab1bcd732b932ead763bf080d90e93ab') }}</div>
        <el-input type="textarea" style="margin-top: 20px;" :disabled="flag != 'audit'" :placeholder="h_i18n('02cc4f8f5a9aefbc03c778f7a5c989c7')" v-model="audittextarea">
        </el-input>
      </div>
      <div class="footerBut">
        <!-- <h-button  size="mini" @click="gomuban()">导出PDF</h-button> -->
        <h-button size="mini" style="margin-right: 12px;" type="primary" v-if="saveTempFlag" @click="saveTemp">{{ h_i18n('d8acae3bcfbc9ec9ade58c2dbacf65aa') }}</h-button>
        <h-button size="mini" style="margin-right: 12px;" :loading="loading" type="primary" v-show="flag == 'edit' || flag == 'add'"
          @click="submit()">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button>
        <h-button size="mini" style="margin-right: 12px;" @click="goBack()">{{ h_i18n('b15d91274e9fc68608c609999e0413fa') }}</h-button>
        <h-button size="mini" style="margin-right: 12px;" :loading="loading" type="primary" v-show="flag == 'audit'" @click="audit('2')">{{ h_i18n('e61f2cc4c39244f627b20e18788c3890') }}</h-button>
        <h-button size="mini" style="margin-right: 12px;" :loading="loading" type="primary" v-show="flag == 'audit'" @click="audit('3')">{{ h_i18n('1bf19c1953d1351b341497c74715e83c') }}</h-button>
        <!-- <h-button v-show="flag == 'check'" size="mini" @click="gomuban()">导出为PDF</h-button> -->
      </div>
    </div>
    <h-upload-template :loading="loadingDown" :title="h_i18n('db547c476bed52ec7c8ea817e929b790')" :show="dialogVisiblechange" @close="closeUpload"
      :dataList="dataList" @download="fileDownload" @fileChange="fileUpload" :question="true">
    </h-upload-template>
</template>


<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import moment from "moment";
import { ElMessage } from "element-plus";
import InspectPhoto from "./inspectPhoto";
export default {
  name: "ShipmentReport",
  components: { InspectPhoto },
  data() {
    return {
      saveTempId: "",
      addFileName: "",
      visiable: false,
      dialogVisible: false,
      dialogVisiblechange: false,
      selectedIndex: "",
      audittextarea: "",
      changeListName: "",
      haseRead: true,
      addArr: [],
      dataList: [],
      input1: "",
      materData: {
        mtlName: "",
        mtlNo: "",
        // authDate:'/'
      },
      options: [
        {
          value: h_i18n('86f720320b77bb62311f0a4811db04fe'),
          label: h_i18n('86f720320b77bb62311f0a4811db04fe'),
        },
        {
          value: h_i18n('6e5a122013138ad189517d5d0a1c0891'),
          label: h_i18n('6e5a122013138ad189517d5d0a1c0891'),
        },
        {
          value: h_i18n('321ff794aab8c6cd671990a98ef212a0'),
          label: h_i18n('321ff794aab8c6cd671990a98ef212a0'),
        },
      ],
      commentList: [
        {
          templateId: h_i18n('09334806287d60f5b2bb2a3719f30fa8'),
          templateCode: h_i18n('09334806287d60f5b2bb2a3719f30fa8'),
          templateName: h_i18n('09334806287d60f5b2bb2a3719f30fa8'),
          itemList: [],
        },
      ],
      filename: h_i18n('fa65e0b2e2675b5ffd35395b6c161741'),
      exportdata: [],
      list: [],
      importancePropertyList: [], // 重要性
      checkLevelList: [],
      supplyCodeList: [],
      editFalg: false,
      disabledRohsNo: false,
      loading: false,
      disabledDate(time) {
        //最大日期是当前日期
        return time.getTime() > Date.now();
      },
      supplyCode: null,
      voteResult: "合格",
      factoryAddressFromQuery: null, // list页传来的factoryAddress
      notEyeFlag: true, // 无天眼
      samplePhotoUuid: null, // 抽样照片uuid
      samplePhoto: null,
      inspectionPocessPhotoUuid: null, //检验过程照片 uuid
      inspectionPocessPhoto: null,
      factoryAddressNew: null, //回传的厂区地址
      paramsData: null,
      statusOfdelete: "",
      starFlag: true,
      saveTempFlag: false,
      timerOf300000: 0, // 5分钟
      timerOf600000: 0, // 10分钟
      timer5M: null,
      timer10M: null,
      isChangeFlag: false,

      zeroFlag: true, // 30天无不合格，取消照片关联
    };
  },
  methods: {
    h_i18n,
    // 透传 inspectPhoto 的统一页面跳转事件。
    changeRouter(...args) {
      this.$emit('changeRouter', ...args)
    },
    // 通过 iframe 消息通知外层 Header，跳转产地管理并同步菜单/URL。
    navigateTo(extraQuery = {}) {
      const safeQuery = extraQuery
        && Object.prototype.toString.call(extraQuery) === '[object Object]'
        ? extraQuery
        : {}
      const payload = {
        url: '/Content/OIDResAddress',
        // 产地管理
        routerName: h_i18n('2A4618C5951EE4383C7CC4E1684B3E67'),
        headerRootId: 41,
        currentMenuId: 4111,
        query: safeQuery
      }
      const message = {
        type: 'SQM_IFRAME_CHANGE_ROUTER',
        payload
      }

      if (window.parent && window.parent !== window) {
        window.parent.postMessage(message, '*')
        return
      }

      this.$emit(
        'changeRouter',
        payload.url,
        payload.routerName,
        payload.headerRootId,
        payload.currentMenuId,
        payload.query
      )
    },
    closeUpload() {
      this.dialogVisiblechange = false;
      this.dataList = [];
      this.status = "";
    },
    fileDownload() {
      //新老路径-下载方法
      let name = h_i18n('8f688805e5245d6c98f777df50a4d2be');
      let url =
        "https://sqm.haier.net/readFile//mkhl/bukl/202312/acc53eb2ba3c4403b5d8873aeda4dffc.xls";
      let pathUrl = "/base/fileDownload/downloadFile?filePath=" + url.split(".net/readFile/")[1];
      this.startLoading("文件下载中...");
      this.httpFile(
        {
          method: "get",
          url: pathUrl,
          headers: { "content-type": "application/json" },
        },
        name
      );
    },
    fileUpload(file) {
      this.startLoading(h_i18n('92cd554eff7896f979917f3ae449b460'));
      let formData = new FormData();
      formData.append("supplyCode", this.supplyCode);
      formData.append("supplyName", this.materData.supplyName);
      formData.append("mtlNo", this.$route.query.mtlNo || this.materData.mtlNo);
      formData.append("mtlName", this.$route.query.mtlName || this.materData.mtlName);
      formData.append("file", file);
      this.$http({
        url: "/base/baseShipmentReport/importTemplate",
        method: "POST",
        headers: { "Content-Type": "multipart/form-data" },
        data: formData,
      }).then((res) => {
        this.closeLoading();
        console.log(res, "模板导入");
        if (res.data.success) {
          this.success(h_i18n('c433b00435d13f2ba0bcb8cdeb67327e'), {
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              callback: (action) => {
                // window.history.go(-1)
              },
            });
          // let newList  = this.tableList.concat(res.data.data)
          let newList = res.data.data;
          for (let i =0;i<this.list.length;i++){
            for(let j = 0;j<this.list[i].itemList.length;j++){
              if(this.list[i].itemList[j].itemName.replace(/\s+/g, '') == newList.itemList[i].itemList[j].itemName.replace(/\s+/g, '')){
                this.list[i].itemList[j].sampleNum = newList.itemList[i].itemList[j].sampleNum
                this.list[i].itemList[j].ac = newList.itemList[i].itemList[j].ac
                this.list[i].itemList[j].re = newList.itemList[i].itemList[j].re
                this.list[i].itemList[j].measured = newList.itemList[i].itemList[j].measured
                this.list[i].itemList[j].voteResult = newList.itemList[i].itemList[j].voteResult
              }
            }
          }
          // for(let i=0;i<this.commentList[0].itemList.length;i++){
          //   if(this.commentList[0].itemList[i].itemName == newList.commonList[i].itemName){
          //     console.log('相同')
          //     // if(newList.commonList[i].itemName == '有害物质'){
          //     //   this.commentList[0].itemList[i].itemName == newList.commonList[i].itemName
          //     //   this.commentList[0].itemList[i].itemName == newList.commonList[i].itemName
          //     //   this.commentList[0].itemList[i].itemName == newList.commonList[i].itemName
          //     // }else if(newList.commonList[i].itemName == '认证情况'){
          //     //   this.commentList[0].itemList[i].itemName == newList.commonList[i].itemName
          //     //   this.commentList[0].itemList[i].itemName == newList.commonList[i].itemName
          //     //   this.commentList[0].itemList[i].itemName == newList.commonList[i].itemName
          //     //   this.commentList[0].itemList[i].itemName == newList.commonList[i].itemName
          //     // }
          //     // else{
          //       this.commentList[0].itemList[i].sampleNum == newList.commonList[i].sampleNum
          //       this.commentList[0].itemList[i].ac == newList.commonList[i].ac
          //       this.commentList[0].itemList[i].re == newList.commonList[i].re
          //       this.commentList[0].itemList[i].measured == newList.commonList[i].measured
          //       this.commentList[0].itemList[i].voteResult == newList.commonList[i].voteResult
          //     // }
          //   }
          // }
          console.log(this.list,this.commentList[0].itemList)
          // this.list = newList.itemList; //企标列表
          this.commentList[0].itemList = newList.commonList; //通用列表
          delete newList.itemList;
          delete newList.commonList;
          this.materData = { ...newList };
          console.log(newList, this.materData, "导入更新后数据");
          this.closeUpload();
          this.getRohs();
          // this.dataList = []
        } else {
          this.status = "error";
          // this.dataList = res.data.msg.split(',')
          this.info(res.data.msg);
        }
      });
    },
    // 暂存功能
    saveTemp(value) {

      if(!this.IsEmpty(this.materData.authDate?.trim())){
        var reDateTime = /^(?:19|20)[0-9][0-9]-(?:(?:0[1-9])|(?:1[0-2]))-(?:(?:[0-2][1-9])|(?:[1-3][0-1]))$/;
        var isDateTime = reDateTime.test(this.materData.authDate);
        console.log(isDateTime, 'isDateTimeisDateTimeisDateTime');
        if (!isDateTime && this.materData.authDate !== '/') {
          // this.info(h_i18n('7f8d0e059e1128349d44137989e27ab7') + h_i18n('6460f46b3607ac4b78225902f085048d') + h_i18n('d4e1c5e0f39fa75363e209da8abe519c'), '', {
          //   dangerouslyUseHTMLString: true
          // });
          this.info(`<span style="color:#165dff;font-weight: 900;">${h_i18n('09334806287d60f5b2bb2a3719f30fa8')}</span>，${h_i18n('7f8d0e059e1128349d44137989e27ab7')}，<span style="color:#f53f3f;font-weight: 900;">${h_i18n('6460f46b3607ac4b78225902f085048d')}</span>${h_i18n('d4e1c5e0f39fa75363e209da8abe519c')}`);
          return false;
        } else {
          console.log('验证通过');
        }
      }

      // 准备数据
      let commonList = [];
      if (this.list !== undefined && this.list.length > 0) {
        this.list.forEach((item) => {
          item.itemList.forEach((child) => {
            commonList.push({
              ...child,
              templateId: item.templateId,
              templateType: item.templateType,
              checkLevel:child.checkLevelName == '/'?child.checkLevelName:child.checkLevel,
              importanceProperty:child.importancePropertyName == '/'?child.importancePropertyName:child.importanceProperty
            });
          });
        });
      }
      this.commentList[0].itemList.forEach((item) =>
        commonList.push({
          ...item,
          templateId: "",
          templateType: "A",
          checkLevel:item.checkLevelName == '/'?item.checkLevelName:item.checkLevel,
          importanceProperty:item.importancePropertyName == '/'?item.importancePropertyName:item.importanceProperty
        })
      );
      let materDataParams = { ...this.materData };
      // materDataParams.samplePhotoUuid = this.samplePhotoUuid
      materDataParams.samplePhoto = this.samplePhoto;
      // materDataParams.inspectionPocessPhotoUuid = this.inspectionPocessPhotoUuid
      materDataParams.inspectionPocessPhoto = this.inspectionPocessPhoto;
      materDataParams.factoryAddressNew = this.factoryAddressNew;
      materDataParams.uploadSamplePhotoTime = this.uploadSamplePhotoTime;
      materDataParams.uploadInspectionPocessPhotoTime = this.uploadInspectionPocessPhotoTime;
      materDataParams.factoryAddressNewId = this.factoryAddressNewId;
      materDataParams.authDate =
        this.materData.authDate == "/" ? "" : this.materData.authDate;
      materDataParams.reportId = this.saveTempId;
      if (this.samplePhotoUuid) {
        materDataParams.samplePhotoUuid = this.samplePhotoUuid.data;
      } else {
        materDataParams.samplePhotoUuid = "";
      }
      if (this.inspectionPocessPhotoUuid) {
        materDataParams.inspectionPocessPhotoUuid = this.inspectionPocessPhotoUuid.data;
      } else {
        materDataParams.inspectionPocessPhotoUuid = "";
      }
      console.log(materDataParams, "基本数据", this.inspectionPocessPhotoUuid);
      if(this.$route.query.mtlName){
        materDataParams.mtlName = this.$route.query.mtlName
      }
      this.$http({
        method: "post",
        // url: '/unload/reports/item/add/snapshot',
        url: "/base/baseShipmentReport/saveSnapshot",
        // headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: {
          ...materDataParams,
          commonList,
        },
      })
        .then((res) => {
          console.log("调用暂存111", res);
          if (res.data.success) {
            this.saveTempId = res.data.data;
            console.log("saveTempId:::::::", this.saveTempId);
            this.success(h_i18n('85dc29bb117cb8640bb43e6cd04987ff'), {
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              callback: (action) => {
                // window.history.go(-1)
              },
            });
            this.isChangeFlag = false;
          }else{
          this.info(res.data.msg)
        }
        })
        .catch((err) => {
          this.error(err);
        });
    },
    // 自动暂存
    saveTempAuto() {
      // 准备数据
      let commonList = [];
      if (this.list !== undefined && this.list.length > 0) {
        this.list.forEach((item) => {
          item.itemList.forEach((child) => {
            commonList.push({
              ...child,
              templateId: item.templateId,
              templateType: item.templateType,
              checkLevel:child.checkLevelName == '/'?child.checkLevelName:child.checkLevel,
              importanceProperty:child.importancePropertyName == '/'?child.importancePropertyName:child.importanceProperty
            });
          });
        });
      }
      this.commentList[0].itemList.forEach((item) =>
        commonList.push({
          ...item,
          templateId: "",
          templateType: "A",
          checkLevel:item.checkLevelName == '/'?item.checkLevelName:item.checkLevel,
          importanceProperty:item.importancePropertyName == '/'?item.importancePropertyName:item.importanceProperty
        })
      );
      let materDataParams = { ...this.materData };
      // materDataParams.samplePhotoUuid = this.samplePhotoUuid
      materDataParams.samplePhoto = this.samplePhoto;
      // materDataParams.inspectionPocessPhotoUuid = this.inspectionPocessPhotoUuid
      materDataParams.inspectionPocessPhoto = this.inspectionPocessPhoto;
      materDataParams.factoryAddressNew = this.factoryAddressNew;
      materDataParams.uploadSamplePhotoTime = this.uploadSamplePhotoTime;
      materDataParams.uploadInspectionPocessPhotoTime = this.uploadInspectionPocessPhotoTime;
      materDataParams.factoryAddressNewId = this.factoryAddressNewId;
      materDataParams.authDate =
        this.materData.authDate == "/" ? "" : this.materData.authDate;
      materDataParams.reportId = this.saveTempId;
      // console.log('调用自动暂存')
      if (this.samplePhotoUuid) {
        materDataParams.samplePhotoUuid = this.samplePhotoUuid.data;
      } else {
        materDataParams.samplePhotoUuid = "";
      }
      if (this.inspectionPocessPhotoUuid) {
        materDataParams.inspectionPocessPhotoUuid = this.inspectionPocessPhotoUuid.data;
      } else {
        materDataParams.inspectionPocessPhotoUuid = "";
      }
      this.$http({
        method: "post",
        // url: '/unload/reports/item/add/snapshot',
        url: "/base/baseShipmentReport/saveSnapshot",
        data: {
          ...materDataParams,
          commonList,
        },
      }).then((res) => {
        console.log("调用暂存2222", res);
        if (res.data.success) {
          this.saveTempId = res.data.data;
          this.$message({ message: h_i18n('35f2729258b7d0cf7965a24564434974'), type: "success" });
          // ElMessage({ message: '自动暂存', type: 'success' })
          this.isChangeFlag = false;
        }else{
          this.info(res.data.msg)
        }
      });
    },
    /**
     * 获取图片及地址
     */
    getImageAndFAddress(obj) {
      console.log("obj", obj);
      this.samplePhotoUuid = obj.samplePhotoUuid;
      this.samplePhoto = obj.samplePhoto;
      this.inspectionPocessPhotoUuid = obj.inspectionPocessPhotoUuid;
      this.inspectionPocessPhoto = obj.inspectionPocessPhoto;
      this.factoryAddressNew = obj.factoryAddressNew;
      this.uploadSamplePhotoTime = obj.uploadSamplePhotoTime;
      this.uploadInspectionPocessPhotoTime = obj.uploadInspectionPocessPhotoTime;
      this.factoryAddressNewId = obj.factoryAddressNewId;
      // this.isChangeFlag = true
      if(obj.samplePhotoUuid)this.materData.samplePhotoUuid = obj.samplePhotoUuid
      if(obj.inspectionPocessPhotoUuid)this.materData.inspectionPocessPhotoUuid  = obj.inspectionPocessPhotoUuid;
      if(obj.factoryAddressNewId)this.materData.factoryAddressNewId = obj.factoryAddressNewId;
    },
    /**
     * 组件删除照片的回调
     */
    deletePhoto(type) {
      if (type === 2) {
        this.samplePhotoUuid = null;
      } else if (type === 3) {
        this.inspectionPocessPhotoUuid = null;
      }
    },
    getPdf() {
      console.log(document.body.scrollTop);
      console.log(document.getElementsByClassName("shipmentReport")[0].scrollTop);
      document.body.scrollTop = 0;
      //document.getElementsByClassName("shipmentReport")[0]
      setTimeout(() => {
        pdfDownlod(
          document.getElementsByClassName("shipmentReport")[0],
          h_i18n('cfe99187b32b2d9c7ae162ade4544aea')
        );
      }, 300);
    },
    goBack() {
      if (this.flag != "edit" && this.flag != "add") {
        window.history.go(-1);
        return;
      }
      if (this.isChangeFlag) {
        this.info({
          title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
          confirmButtonText: h_i18n('0a60ac8f02ccd2cf723f927284877851'),
          cancelButtonText: h_i18n('c9744f45e76d885ae1c74d4f4a934b2e'),
          message: h_i18n('89151df5543015c6222e27c05640949c'),
          callback: (action) => {
            console.log(action, "----------------------------");
            if (action === "confirm") {
              this.saveTemp(true);
              this.$router.back();
            } else {
              this.$router.back();
            }
          },
        });
        // this.info('当前内容未保存，是否保存后离开？', '提示', {
        //   distinguishCancelAndClose: true,
        //   confirmButtonText: '是',
        //   cancelButtonText: '否',
        //   callback: action => {
        //     if (action == "confirm") {
        //       // 先暂存，再返回
        //       this.saveTemp()
        //       console.log('暂存了')
        //       window.history.go(-1)
        //     } else if (action == "close") {
        //     } else {
        //       // 直接返回
        //       console.log('不存了', action)
        //       window.history.go(-1)
        //     }
        //   },
        //   customstyle: {
        //     paddingleft: '0px'
        //   }
        // })
      } else {
        window.history.go(-1);
      }
      document.body.style = { "padding-right": "0px" };
    },
    // 打印模板
    gomuban() {
      this.$router.push({
        path: "/muban",
        query: {
          supplyCode: this.supplyCode,
          exportdata: JSON.stringify(this.exportdata),
          materData: JSON.stringify(this.materData),
          list: JSON.stringify(this.list),
          commentList: JSON.stringify(this.commentList[0].itemList),
          importancePropertyList: JSON.stringify(this.importancePropertyList),
          checkLevelList: JSON.stringify(this.checkLevelList),
        },
      });
    },
    //  关闭弹窗
    handleClose(done) {
      done();
    },
    /**
     * @description:  新增检验标准弹窗
     * @param {*} index  用来记录需要添加标准的下标
     * @param {*} listType  需要处理的文件
     * @return {*}
     */
    addStandard(index, listType) {
      this.selectedIndex = index;
      this.changeListName = listType;
      this.dialogVisible = true;
    },
    // /rohs
    getRohs() {
      if (this.flag != "edit" && this.flag != "add") {
        return;
      }
      this.$http({
        method: "get",
        // url: '/unload/rohs',
        url: "/base/conformityDeclaration/selectRohsInfo", //金鹏新接口
        // headers: { 'content-type': 'application/x-www-form-urlencoded' },
        params: { mtlNo: this.materData.mtlNo, supplyCode: this.supplyCode },
      }).then((res) => {
        console.log('3333333getrohs',res)
          if (res.data.data && res.data.data.rohsNo) {
            this.materData.rohsNo = res.data.data.rohsNo;
            this.materData.rohsDate = res.data.data.effectEndDate;
            this.disabledRohsNo = true;
          }
      });
    },
    // 根据专用号查询物料信息
    getMatName(mtlNo) {
      this.$http({
        method: "get",
        // url: '/unload/mkl/info',
        url: "/base/baseShipmentTemplate/mklInfo",
        // headers: { 'content-type': 'application/x-www-form-urlencoded' },
        params: { mtlNo, supplyCode: this.supplyCode },
      }).then((res) => {
        // console.log('44444444_new',res)
        if (res.data.success) {
          this.materData = {
            ...res.data.data,
          };
          if (
            res.data.data.authDate == undefined ||
            res.data.data.authDate == null ||
            res.data.data.authDate == ""
          ) {
            this.materData.authDate = "";
          } else {
            this.materData.authDate = moment(res.data.data.authDate).format("YYYY-MM-DD");
          }
          this.getRohs();
        }
      });
    },
    //unload/通用/list
    getCommonTemplateList(mtlNo) {
      this.$http({
        method: "get",
        // url: '/unload/common/list',
        url: "/base/baseShipmentTemplate/commonInfo",
        // headers: { 'content-type': 'application/x-www-form-urlencoded' },
        params: { mtlNo, supplyCode: this.supplyCode },
      })
        .then((res) => {
          console.log(res, "555555555_new");
          if (res.data.success) {
            if (res.data.data && res.data.data.length) {
              this.commentList[0].itemList = res.data.data;
            }
          }
        })
        .catch((err) => {
          this.info(err.message);
        });
    },
    //unload/item/list   标准列表
    getTemplateList(mtlNo) {
      this.$http({
        method: "get",
        // url: '/unload/item/list',
        url: "/base/baseShipmentTemplate/tempInfo",
        // headers: { 'content-type': 'application/x-www-form-urlencoded' },
        params: { mtlNo, supplyCode: this.supplyCode },
      })
      .then((res) => {
        console.log(res,'66666666666_new')
        if (res.data.success) {
          if (res.data.data && res.data.data.length) {
            this.list = res.data.data;
            }
          }
        })
        .catch((err) => {
          this.info(err.message);
        });
    },
    checkvalue(a, b) {
      let avlue = "";
      let bvlue = "";
      if (a == "" || a == null || a == undefined) {
        avlue = "";
      } else {
        avlue = a;
      }
      if (b == "" || b == null || b == undefined) {
        bvlue = "";
      } else {
        bvlue = b;
      }
      if (avlue == "" && bvlue == "") {
        return true;
      } else {
        return false;
      }
    },
    // 获取deleteStatus
    getDeleteStatusBySupplyCode() {
      // console.log('查询deleteStatus')
      this.$http({
        url: "/base/visualeye/listPage",
        method: "post",
        data: {
          pageNo: 1,
          pageSize: 10,
          supplyCode: this.supplyCode,
        },
      }).then((res) => {
        console.log("77777", res);
        if (res.data.code != "200" || res.data.data.records.length == 0) {
          this.notEyeFlag = true; // 无天眼
          return;
        }
        // res.data.data.supplyScreenDTOPage?.list?.length > 0 ? console.log("deleteStatus",res.data.data.supplyScreenDTOPage.list[0].deleteStatus) : ''
        let screenDeleteStatus = res.data.data.records[0].deleteStatus;
        this.statusOfdelete = screenDeleteStatus;
        this.notEyeFlag = false; // 有天眼
        if (screenDeleteStatus == "N") {
          // deleteStatus = N 必须截图
          this.zeroFlag = false;
          if (this.editFalg) {
            // editFalg =true 非新增及修改
            if (!this.materData.samplePhotoUuid) {
              // 如果有新地址
              this.materData.factoryAddressNewId &&
                (this.paramsData = {
                  // 给截图组件传参
                  componentsFactoryAddressNewId: this.materData.factoryAddressNewId,
                  componentsFactoryAddressNew: this.materData.factoryAddressNew,
                });
              return;
            }
            this.paramsData = {
              // 给截图组件传参
              componentsFactoryAddressNewId: this.materData.factoryAddressNewId,
              componentsFactoryAddressNew: this.materData.factoryAddressNew,
              componentsSamplePhotoUuid: this.materData.samplePhotoUuid
                ? `https://sqm.haier.net/readFile/${this.materData.samplePhotoUuid}`
                : undefined, // 抽样样品照片
              componentsInspectionPocessPhotoUuid: this.materData
                .inspectionPocessPhotoUuid
                ? `https://sqm.haier.net/readFile/${this.materData.inspectionPocessPhotoUuid}`
                : undefined, // 检验过程照片
              componentsUploadSamplePhotoTime: this.materData.uploadSamplePhotoTime, //抽样样品照片时间
              componentsUploadInspectionPocessPhotoTime: this.materData
                .uploadInspectionPocessPhotoTime, //检验过程照片时间
            };
          } else if (this.$route.query.flag == "edit") {
            // 如果是修改
            this.paramsData = {
              // 给截图组件传回显
              backFactoryAddressNewId: this.materData.factoryAddressNewId,
              backFactoryAddressNew: this.materData.factoryAddressNew,
              backFactoryAddress: this.materData.factoryAddressNew,
              backSamplePhotoUuid: this.materData.samplePhotoUuid
                ? `https://sqm.haier.net/readFile/${this.materData.samplePhotoUuid}`
                : undefined, // 抽样样品照片
              backInspectionPocessPhotoUuid: this.materData.inspectionPocessPhotoUuid
                ? `https://sqm.haier.net/readFile/${this.materData.inspectionPocessPhotoUuid}`
                : undefined, // 检验过程照片
              backUploadSamplePhotoTime: this.materData.uploadSamplePhotoTime, //抽样样品照片时间
              backUploadInspectionPocessPhotoTime: this.materData
                .uploadInspectionPocessPhotoTime, //检验过程照片时间
            };
          }
        } else if (screenDeleteStatus == "Y") {
          // 不能截图
          // if(this.materData.samplePhotoUuid){ // 有图片就回显
          this.paramsData = {};
          if (this.$route.query.flag == "edit") {
            // 如果是修改
            this.paramsData = {
              // 给截图组件传回显
              backFactoryAddressNewId: this.materData.factoryAddressNewId,
              backFactoryAddressNew: this.materData.factoryAddressNew,
              backFactoryAddress: this.materData.factoryAddressNew,
              backSamplePhotoUuid: this.materData.samplePhotoUuid
                ? `https://sqm.haier.net/readFile/${this.materData.samplePhotoUuid}`
                : undefined, // 抽样样品照片
              backInspectionPocessPhotoUuid: this.materData.inspectionPocessPhotoUuid
                ? `https://sqm.haier.net/readFile/${this.materData.inspectionPocessPhotoUuid}`
                : undefined, // 检验过程照片
              backUploadSamplePhotoTime: this.materData.uploadSamplePhotoTime, //抽样样品照片时间
              backUploadInspectionPocessPhotoTime: this.materData
                .uploadInspectionPocessPhotoTime, //检验过程照片时间
            };
          } else if (this.$route.query.flag == "add") {
          } else {
            this.paramsData = {
              // 给截图组件传参
              componentsFactoryAddressNewId: this.materData.factoryAddressNewId,
              componentsFactoryAddressNew: this.materData.factoryAddressNew,
              componentsFactoryAddress: this.materData.factoryAddressNew,
              componentsSamplePhotoUuid: this.materData.samplePhotoUuid
                ? `https://sqm.haier.net/readFile/${this.materData.samplePhotoUuid}`
                : undefined, // 抽样样品照片
              componentsInspectionPocessPhotoUuid: this.materData
                .inspectionPocessPhotoUuid
                ? `https://sqm.haier.net/readFile/${this.materData.inspectionPocessPhotoUuid}`
                : undefined, // 检验过程照片
              componentsUploadSamplePhotoTime: this.materData.uploadSamplePhotoTime, //抽样样品照片时间
              componentsUploadInspectionPocessPhotoTime: this.materData
                .uploadInspectionPocessPhotoTime, //检验过程照片时间
            };
          }
          this.zeroFlag = true;
          this.starFlag = false;
          // }
        } else {
          this.zeroFlag = false;
        }
      });
    },
    // 导入模板
    Importmuban() {
      this.dialogVisiblechange = true;
    },
    // 导入文件
    getFile(event) {
      console.log(event, "1111");
      this.addArr = [];
      let file = event.target.files;
      this.addFileName = file.name;
      this.addArr.push(file);
      console.log(this.addArr);
    },
    // 提交导入文件
    // submitAddFile() {
    //   if (0 == this.addArr.length) {
    //     this.$message({
    //       type: "info",
    //       message: h_i18n('68ea13ee8ca0e8a512f33dacf3e6d788'),
    //     });
    //     return;
    //   }
    //   let formdata = new FormData();
    //   formdata.append("myfile", this.addArr[0][0]);
    //   this.$http({
    //     method: "post",
    //     url: "/unload/import/importTemplate",
    //     headers: { "Content-Type": "multipart/form-data" },
    //     data: formdata,
    //     cache: false,
    //     processData: false,
    //     contentType: false,
    //   })
    //     .then((res) => {
    //       console.log("888888", res);
    //       // 遍历带标准编号的 根据id遍历出来name
    //       !res.data && console.log("请求数据错误，联系管理员");
    //       for (let i = 0; i < this.list.length; i++) {
    //         for (let j = 0; j < this.list[i].itemList.length; j++) {
    //           for (let k = 0; k < this.importancePropertyList.length; k++) {
    //             if (
    //               this.list[i].itemList[j].importanceProperty ==
    //               this.importancePropertyList[k].valueId
    //             ) {
    //               this.list[i].itemList[
    //                 j
    //               ].importancePropertyName = this.importancePropertyList[k].valueName;
    //               break;
    //             }
    //           }
    //           for (let k = 0; k < this.checkLevelList.length; k++) {
    //             if (
    //               this.list[i].itemList[j].checkLevel == this.checkLevelList[k].valueId
    //             ) {
    //               this.list[i].itemList[j].checkLevelName = this.checkLevelList[
    //                 k
    //               ].valueName;
    //               break;
    //             }
    //           }
    //         }
    //       }
    //       // 遍历通用的 根据id遍历出来name
    //       for (let i = 0; i < this.commentList[0].itemList.length; i++) {
    //         for (let k = 0; k < this.importancePropertyList.length; k++) {
    //           if (
    //             this.commentList[0].itemList[i].importanceProperty ==
    //             this.importancePropertyList[k].valueId
    //           ) {
    //             this.commentList[0].itemList[
    //               i
    //             ].importancePropertyName = this.importancePropertyList[k].valueName;
    //             break;
    //           } else if (this.commentList[0].itemList[i].importanceProperty === "/") {
    //             this.commentList[0].itemList[i].importancePropertyName = "/";
    //             break;
    //           }
    //         }
    //         for (let k = 0; k < this.checkLevelList.length; k++) {
    //           if (
    //             this.commentList[0].itemList[i].checkLevel ==
    //             this.checkLevelList[k].valueId
    //           ) {
    //             this.commentList[0].itemList[i].checkLevelName = this.checkLevelList[
    //               k
    //             ].valueName;
    //             break;
    //           } else if (this.commentList[0].itemList[i].checkLevel === "/") {
    //             this.commentList[0].itemList[i].checkLevelName = "/";
    //             break;
    //           }
    //         }
    //       }
    //       // 新增的导入
    //       console.log(res, "新增数据");
    //       console.log(this.materData, "已有数据页头页脚总数据");
    //       console.log(this.list, "已有数据标准list");
    //       console.log(this.commentList[0].itemList, "已有数据conmmilist");
    //       if (this.isObjEqual(res.data.baseShipmentReportDTO, this.materData, "1")) {
    //         console.log("对比总数据");
    //       } else {
    //         this.info(
    //           h_i18n('8e8682706b3b07a3e8d8797e3b74c8ae'),
    //           "",
    //           {
    //             dangerouslyUseHTMLString: true,
    //           }
    //         );
    //         return false;
    //       }
    //       if (this.isObjEqual(res.data.itemList, this.list, "2")) {
    //         console.log("对比标准列表");
    //       } else {
    //         this.info(
    //           h_i18n('8e8682706b3b07a3e8d8797e3b74c8ae'),
    //           "",
    //           {
    //             dangerouslyUseHTMLString: true,
    //           }
    //         );
    //         return false;
    //       }
    //       if (this.isObjEqual(res.data.commonList, this.commentList[0].itemList, "3")) {
    //         console.log("对比通用列表");
    //       } else {
    //         this.info(
    //           h_i18n('8e8682706b3b07a3e8d8797e3b74c8ae'),
    //           "",
    //           {
    //             dangerouslyUseHTMLString: true,
    //           }
    //         );
    //         return false;
    //       }
    //       this.materData.supplyBacth = res.data.baseShipmentReportDTO.supplyBacth;
    //       this.materData.bacthLine = res.data.baseShipmentReportDTO.bacthLine;
    //       this.materData.bacthProductDate =
    //         res.data.baseShipmentReportDTO.bacthProductDate;
    //       this.materData.shiftProduct = res.data.baseShipmentReportDTO.shiftProduct;
    //       this.materData.factoryAddress = res.data.baseShipmentReportDTO.factoryAddress;
    //       this.materData.bacthNum = res.data.baseShipmentReportDTO.bacthNum;
    //       this.materData.authName = res.data.baseShipmentReportDTO.authName;
    //       this.materData.authNo = res.data.baseShipmentReportDTO.authNo;
    //       if (
    //         res.data.baseShipmentReportDTO.authDate == undefined ||
    //         res.data.baseShipmentReportDTO.authDate == null ||
    //         res.data.baseShipmentReportDTO.authDate == ""
    //       ) {
    //         this.materData.authDate = "";
    //       } else {
    //         this.materData.authDate = moment(
    //           res.data.baseShipmentReportDTO.authDate
    //         ).format("YYYY-MM-DD");
    //       }
    //       this.materData.rohsNo = res.data.baseShipmentReportDTO.rohsNo;
    //       this.materData.rohsDate = res.data.baseShipmentReportDTO.rohsDate;
    //       this.materData.checkResult = res.data.baseShipmentReportDTO.checkResult;
    //       this.materData.checkEmpName = res.data.baseShipmentReportDTO.checkEmpName;
    //       this.materData.checkDate = res.data.baseShipmentReportDTO.checkDate;
    //       this.materData.auditEmpName = res.data.baseShipmentReportDTO.auditEmpName;
    //       this.materData.auditDate = res.data.baseShipmentReportDTO.auditDate;
    //       for (let i = 0; i < this.list.length; i++) {
    //         for (let k = 0; k < this.list[i].itemList.length; k++) {
    //           this.list[i].itemList[k].sampleNum =
    //             res.data.itemList[i].itemList[k].sampleNum;
    //           this.list[i].itemList[k].ac = res.data.itemList[i].itemList[k].ac;
    //           this.list[i].itemList[k].re = res.data.itemList[i].itemList[k].re;
    //           this.list[i].itemList[k].measured =
    //             res.data.itemList[i].itemList[k].measured;
    //           this.list[i].itemList[k].voteResult =
    //             res.data.itemList[i].itemList[k].voteResult;
    //         }
    //       }
    //       for (let i = 0; i < this.commentList[0].itemList.length; i++) {
    //         this.commentList[0].itemList[i].sampleNum = res.data.commonList[i].sampleNum;
    //         this.commentList[0].itemList[i].ac = res.data.commonList[i].ac;
    //         this.commentList[0].itemList[i].re = res.data.commonList[i].re;
    //         this.commentList[0].itemList[i].measured = res.data.commonList[i].measured;
    //         this.commentList[0].itemList[i].voteResult =
    //           res.data.commonList[i].voteResult;
    //       }
    //       this.getRohs();
    //       this.dialogVisiblechange = false;
    //       console.log(this.materData, "最终数据页头页脚总数据");
    //       console.log(this.list, "最终数据标准list");
    //       console.log(this.commentList[0].itemList, "最终数据conmmilist");
    //       // 数据改变，调整暂存状态
    //       this.isChangeFlag = true;
    //     })
    //     .catch((err) => {
    //       this.info(
    //         h_i18n('8e8682706b3b07a3e8d8797e3b74c8ae'),
    //         "",
    //         {
    //           dangerouslyUseHTMLString: true,
    //         }
    //       );
    //     });
    // },
    // 对比导入的报告和已有的报告
    isObjEqual(o1, o2, tags) {
      if (tags == "1") {
        if (o1["supplyName"] !== o2["supplyName"]) {
          console.log("1");
          return false;
        } else if (o1["supplyCode"] !== o2["supplyCode"]) {
          console.log("2");
          return false;
        } else if (o1["mtlName"] !== o2["mtlName"]) {
          console.log("3");
          return false;
        } else if (o1["mtlNo"] !== o2["mtlNo"]) {
          console.log("4");
          return false;
        }
        return true;
      } else if (tags == "2") {
        if (o1.length != o2.length) {
          return false;
        }
        // let list=['templateName','templateCode']
        // let listlist=['templateName','templateCode']
        for (let i = 0; i < o1.length; i++) {
          if (o1[i]["templateName"] != o2[i]["templateName"]) {
            console.log(o1[i]["templateName"]);
            console.log(o2[i]["templateName"]);
            console.log("1");
            return false;
          } else if (o1[i]["templateCode"] != o2[i]["templateCode"]) {
            console.log("2");
            console.log(o1[i]["templateCode"]);
            console.log(o2[i]["templateCode"]);
            return false;
          } else {
            if (o1[i].itemList.length != o2[i].itemList.length) {
              return false;
            }
            for (let k = 0; k < o1[i].itemList.length; k++) {
              if (
                o1[i].itemList[k]["itemName"].replace(/\s*/g, "") !=
                o2[i].itemList[k]["itemName"].replace(/\s*/g, "")
              ) {
                console.log(o1[i].itemList[k]["itemName"]);
                console.log(o2[i].itemList[k]["itemName"]);
                console.log("3");
                return false;
              } else if (
                o1[i].itemList[k]["remark"].replace(/\s*/g, "") !==
                o2[i].itemList[k]["remark"].replace(/\s*/g, "")
              ) {
                console.log(o1[i].itemList[k]["remark"].replace(/\s*/g, ""));
                console.log(o2[i].itemList[k]["remark"].replace(/\s*/g, ""));
                console.log("4");
                return false;
              } else if (
                o1[i].itemList[k]["importancePropertyName"] !=
                o2[i].itemList[k]["importancePropertyName"]
              ) {
                console.log(o1[i].itemList[k]["importancePropertyName"]);
                console.log(o2[i].itemList[k]["importancePropertyName"]);
                console.log("5");
                return false;
              } else if (
                o1[i].itemList[k]["checkLevelName"] != o2[i].itemList[k]["checkLevelName"]
              ) {
                console.log(o1[i].itemList[k]["checkLevelName"]);
                console.log(o2[i].itemList[k]["checkLevelName"]);
                console.log("6");
                return false;
              } else if (
                o1[i].itemList[k]["aqlProperty"] != o2[i].itemList[k]["aqlProperty"]
              ) {
                console.log(o1[i].itemList[k]["aqlProperty"]);
                console.log(o2[i].itemList[k]["aqlProperty"]);
                console.log("7");
                return false;
              }
            }
          }
        }
        return true;
      } else if (tags == "3") {
        if (o1.length != o2.length) {
          return false;
        }
        // let list=['templateName','templateCode']
        // let listlist=['templateName','templateCode']
        for (let i = 0; i < o1.length; i++) {
          if (o2[i].itemName == "有害物质") {
            if (
              o2[i]["rohsNo"] == undefined ||
              o2[i]["rohsNo"] == null ||
              o2[i]["rohsNo"] == ""
            ) {
              console.log("有害物质为空");
            } else {
              console.log("有害物质有值");
              if (o1[i]["rohsNo"] !== o2[i]["rohsNo"]) {
                console.log("1");
                return false;
              } else if (o1[i]["rohsDate"] !== o2[i]["rohsDate"]) {
                console.log("2");
                return false;
              } else if (o1[i]["voteResult"] !== o2[i]["voteResult"]) {
                console.log("3");
                console.log(o1[i]);
                console.log(o2[i]);
                return false;
              } else {
                return true;
              }
            }
          } else if (o1[i].itemName == "认证情况") {
          } else {
            if (
              o1[i]["itemName"].replace(/\s*/g, "") !==
              o2[i]["itemName"].replace(/\s*/g, "")
            ) {
              console.log("1");
              return false;
            } else if (this.factory(o1[i]["remark"]) !== this.factory(o2[i]["remark"])) {
              console.log("2");
              return false;
            } else if (
              o1[i]["importancePropertyName"] !== o2[i]["importancePropertyName"]
            ) {
              console.log("3");
              console.log(o1[i]);
              console.log(o2[i]);
              return false;
            } else if (o1[i]["checkLevelName"] !== o2[i]["checkLevelName"]) {
              console.log(o1[i]);
              console.log(o2[i]);
              console.log("4");
              return false;
            } else if (o1[i]["aqlProperty"] !== o2[i]["aqlProperty"]) {
              console.log("5");
              return false;
            }
          }
        }
      }
      return true;
    },
    factory(v) {
      return `${v.replaceAll('"', "").replace(/\s*/g, "")}`;
    },
    // 导出模板
    exportmuban() {
      this.startLoading(h_i18n('6477b96bf459a9a91e1da7a0e8caaa80'));
      console.log(this.importancePropertyList, "全部重要性");
      console.log(this.checkLevelList, "全部检查水平");
      console.log(this.exportdata, "已有的");
      let datavalu = {};
      if (this.$route.query.reportId) {
        datavalu = JSON.parse(JSON.stringify(this.exportdata));
      } else {
        console.log(this.materData, "materData");
        console.log(this.list, "list");
        console.log(this.commentList[0].itemList, "commentList");
        datavalu.itemList = this.list;
        datavalu.commonList = this.commentList[0].itemList;
      }
      // 遍历带标准编号的 根据id遍历出来名字
      for (let i = 0; i < datavalu.itemList.length; i++) {
        for (let j = 0; j < datavalu.itemList[i].itemList.length; j++) {
          for (let k = 0; k < this.importancePropertyList.length; k++) {
            if (
              datavalu.itemList[i].itemList[j].importanceProperty ==
              this.importancePropertyList[k].valueId
            ) {
              datavalu.itemList[i].itemList[
                j
              ].importancePropertyName = this.importancePropertyList[k].valueName;
              break;
            }
          }
          for (let k = 0; k < this.checkLevelList.length; k++) {
            if (
              datavalu.itemList[i].itemList[j].checkLevel ==
              this.checkLevelList[k].valueId
            ) {
              datavalu.itemList[i].itemList[j].checkLevelName = this.checkLevelList[
                k
              ].valueName;
              break;
            }
          }
        }
      }
      // 遍历通用的
      for (let i = 0; i < datavalu.commonList.length; i++) {
        for (let k = 0; k < this.importancePropertyList.length; k++) {
          if (
            datavalu.commonList[i].importanceProperty ==
            this.importancePropertyList[k].valueId
          ) {
            datavalu.commonList[i].importancePropertyName = this.importancePropertyList[
              k
            ].valueName;
            break;
          }
        }
        for (let k = 0; k < this.checkLevelList.length; k++) {
          if (datavalu.commonList[i].checkLevel == this.checkLevelList[k].valueId) {
            datavalu.commonList[i].checkLevelName = this.checkLevelList[k].valueName;
            break;
          }
        }
      }
      console.log(datavalu, "this.exportdatathis.exportdata");

      if (this.materData.name) {
        delete this.materData.name;
      }
      if (this.materData.nickName) {
        delete this.materData.nickName;
      }
      if(this.$route.query.mtlName){
        this.materData.mtlName = this.$route.query.mtlName
      }
      let list = { ...this.materData };
      this.$http({
        method: "post",
        // url: '/unload/export/exportTemplate',
        url: "/base/baseShipmentReport/exportTemplate",
        // headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: {
          ...datavalu,
          ...list,
          commonList:list.commonList ? list.commonList : datavalu.commonList // mtlInfo接口不返回commonList了
        },
        responseType: "blob",
      }).then((res) => {
        this.closeLoading()
        console.log("999999_new", res);
        let blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let objectUrl = URL.createObjectURL(blob);
        console.log(objectUrl);
        const elink = document.createElement("a");
        elink.download = this.materData.mtlNo + this.filename; //下载文件名称,
        elink.style.display = "none";
        elink.href = objectUrl;
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
        // 这里也可以不创建a链接，直接window.open(href)也能下载
      });
    },
    IsEmpty(value) {
      return value === '' || value === null || value === undefined;
    },
    Info(id, index, value, prefix = true, end = h_i18n('ee68958200b067557acc666757b4bcaa')) {
      this.info(`${prefix ? h_i18n('93857b3e7110f600d178883ce9b9bbe5') : ''}<span style="color:#165dff;font-weight: 900;">${id}</span>，${h_i18n('40dda7406da9994319e1e46faaac71ac')}${index}，<span style="color:#f53f3f;font-weight: 900;">${value}</span>${end}`);
    },
    // /reports/item/audit 审批方法
    submit() {
      if (!this.haseRead) {//请阅读质量承诺，并选择已阅读并同意
        this.info(h_i18n('fc090ec29467aa95c8456777e9cad400'), h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), {
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: (action) => {
            if (action == "cancel") {
            }
          },
        });
        return;
      }
      if (isNaN(Number(this.materData.bacthNum))) {
        this.materData.bacthNum = "";//本批生产数量需填写数字
        this.info(h_i18n('38867a4c2e38c59f0c8009686f0ebb1c'), h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), {
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        });
        return;
      }

      let mapping = {
        sampleNum: h_i18n('9e23b61ce24cfada6fea1cdc2277976c'), //样本大小
        ac: 'Ac',
        re: 'Re',
        measured: h_i18n('c5fb490f9763ca6e6320049b20e23a92'), //实测值
        voteResult: h_i18n('4158228943415a8cc85084d68ef18802'), //单项判定
      };

      let reg = new RegExp(/^-?\d+(\.\d+)?$/);
      let text_reg = new RegExp(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FAFF}\u{1F018}-\u{1F270}\u{238C}-\u{2454}\u{20D0}-\u{20FF}\u{FE00}-\u{FE0F}\u{1F004}\u{1F0CF}\u{1F170}-\u{1F251}\u{1F910}-\u{1F96B}\u{1F980}-\u{1F997}\u{1F9C0}\u{1F9D0}-\u{1F9E6}\u{200D}\u{FE0E}\u{FE0F}\u{E0020}-\u{E007F}\u{1F191}-\u{1F19A}\u{1F201}\u{1F21A}\u{1F22F}\u{1F232}-\u{1F236}\u{1F238}-\u{1F23A}\u{1F250}-\u{1F251}\u{1F310}-\u{1F320}\u{1F32D}-\u{1F335}\u{1F337}-\u{1F37C}\u{1F37E}-\u{1F393}\u{1F3A0}-\u{1F3CA}\u{1F3CF}-\u{1F3D3}\u{1F3E0}-\u{1F3F0}\u{1F3F4}\u{1F3F8}-\u{1F43E}\u{1F440}\u{1F442}-\u{1F4FC}\u{1F4FF}-\u{1F53D}\u{1F54B}-\u{1F54E}\u{1F550}-\u{1F567}\u{1F57A}\u{1F595}-\u{1F596}\u{1F5A4}\u{1F5FB}-\u{1F64F}\u{1F6C0}-\u{1F6C5}\u{1F6CC}\u{1F6D0}-\u{1F6D2}\u{1F6EB}-\u{1F6EC}\u{1F6F4}-\u{1F6F9}\u{1F910}-\u{1F93E}\u{1F940}-\u{1F970}\u{1F973}-\u{1F976}\u{1F97A}\u{1F97C}-\u{1F9A2}\u{1F9B0}-\u{1F9B9}\u{1F9C0}-\u{1F9C2}\u{1F9D0}-\u{1F9FF}\u{1FA70}-\u{1FA73}\u{1FA78}-\u{1FA7A}\u{1FA80}-\u{1FA82}\u{1FA90}-\u{1FA95}]/gu);

      let _this = this;
      let haseNoVoteResult = false;
      if (this.list !== undefined && this.list.length > 0) {
        for (let i = 0; i < _this.list.length; i++) {
          if (_this.list[i].itemList) {
            let listItem = _this.list[i];
            for (let j = 0; j < listItem.itemList.length; j++) {
              let item = _this.list[i].itemList[j];

              //2026-10-21 将提示具体到字段
              let ll = Object.keys(mapping);

              for (const itm of ll) {

                //判断空
                if (this.IsEmpty(item[itm]?.trim())) {
                  this.Info(listItem.templateCode, j + 1, mapping[itm]);
                  return;
                }

                //判断值合法
                if (itm === 'sampleNum' || itm === 'ac' || itm === 're') {
                  if (item[itm] !== '/' && !reg.test(item[itm]?.trim())) {
                    this.Info(listItem.templateCode, j + 1, mapping[itm], true, h_i18n('0c7dc68e9723fc908ac3c687f7623863'));
                    return;
                  }
                }

                //判断实测值合法
                if (itm === 'measured') {
                  if (text_reg.test(item[itm]?.trim())) {
                    this.Info(listItem.templateCode, j + 1, mapping[itm], true, h_i18n('6a43db412156e4d1185e387343460170'));
                    return;
                  }
                }
              }




              // if (
              //   !item.sampleNum ||
              //   !item.ac ||
              //   !item.re ||
              //   !item.measured ||
              //   !item.voteResult
              // ) {
              //   // sampleNum  ac  re measured voteResult
              //
              //   this.info( //该templateName 检验标准下，第 数字 条数据存在数据未填写
              //     `${h_i18n('a43b5c6f5d35622bb7284f6c92430691')}${_this.list[i].templateName}${h_i18n('9907025c3fab325138738b540799f542')}${j + 1
              //     }${h_i18n('55eac29b1515b574cf383ba69c7dda0e')}`,
              //     h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'),
              //     {
              //       confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              //     }
              //   );
              //   return;
              // }
              if (item.voteResult == "不合格") {
                haseNoVoteResult = true;
              }
            }
          }
        }
      }

      let mapping_a = {
        authName: h_i18n('9d990c97863816289d46acfd069e87aa'),
        authNo: h_i18n('3d46faf3472658297226f1eaa2d3c169'),
        authDate: h_i18n('bb114ab9e5de7db0d548194e17b6cc01')
      };

      let mapping_b = {
        rohsNo: h_i18n('369d21daf7e505f05a3f16a8acf67ebc'),
        rohsDate: h_i18n('bb114ab9e5de7db0d548194e17b6cc01')
      };

      let item_c = this.materData;

      let date_reg = /^(?:19|20)[0-9][0-9]-(?:(?:0[1-9])|(?:1[0-2]))-(?:(?:[0-2][1-9])|(?:[1-3][0-1]))$/;

      //
      if (_this.commentList[0].itemList) {
        /* child.itemName =='认证情况'  authName authNo authDate voteResult
            有害物质                     rohsNo  rohsDate voteResult */
        for (let j = 0; j < _this.commentList[0].itemList.length; j++) {
          let item = _this.commentList[0].itemList[j];
          console.log("找问题",item)

          if (item.itemName === '认证情况') {

            let ll = Object.keys(mapping_a);

            for (const itm of ll) {

              if (itm === 'authName' || itm === 'authNo') {

                //判空
                if (this.IsEmpty(item_c[itm]?.trim())) {
                  this.Info(h_i18n('09334806287d60f5b2bb2a3719f30fa8'), j + 1, mapping_a[itm], false, h_i18n('ee68958200b067557acc666757b4bcaa'));
                  return;
                }

                //值合法
                if (text_reg.test(item_c[itm]?.trim())) {
                  this.Info(h_i18n('09334806287d60f5b2bb2a3719f30fa8'), j + 1, mapping_a[itm], false, h_i18n('6a43db412156e4d1185e387343460170'));
                  return;
                }
              }

              if (itm === 'authDate') {

                //判空
                if (this.IsEmpty(item_c[itm])) {
                  this.Info(h_i18n('09334806287d60f5b2bb2a3719f30fa8'), j + 1, mapping_a[itm], false, h_i18n('ee68958200b067557acc666757b4bcaa'));
                  return;
                }

                if (!date_reg.test(item_c.authDate) && item_c.authDate !== '/') {
                  this.Info(h_i18n('09334806287d60f5b2bb2a3719f30fa8'), j + 1, mapping_a[itm], false, h_i18n('d4e1c5e0f39fa75363e209da8abe519c'));
                  return;
                }
              }
            }
            if (this.IsEmpty(item.voteResult?.trim()) || item.voteResult === '请选择') {
              this.Info(h_i18n('09334806287d60f5b2bb2a3719f30fa8'), j + 1, h_i18n('b5bbdad51869da73342703720c9657a7'), false, h_i18n('d5b1d036097aeb26456527e4bc06f76e'));
              return;
            }
          } else if (item.itemName === '有害物质') {

            let ll = Object.keys(mapping_b);

            for (const itm of ll) {

              if (itm === 'rohsDate') {
                //判空
                if (this.IsEmpty(item_c[itm])) {
                  this.Info(h_i18n('09334806287d60f5b2bb2a3719f30fa8'), j + 1, mapping_b[itm], false, h_i18n('ee68958200b067557acc666757b4bcaa'));
                  return;
                }
              }else{
                //判空
                if (this.IsEmpty(item_c[itm]?.trim())) {
                  this.Info(h_i18n('09334806287d60f5b2bb2a3719f30fa8'), j + 1, mapping_b[itm], false, h_i18n('ee68958200b067557acc666757b4bcaa'));
                  return;
                }
              }


              if (itm === 'rohsNo') {
                //值合法
                if (text_reg.test(item_c[itm]?.trim())) {
                  this.Info(h_i18n('09334806287d60f5b2bb2a3719f30fa8'), j + 1, mapping_b[itm], false, h_i18n('6a43db412156e4d1185e387343460170'));
                  return;
                }
              }
            }
            if (this.IsEmpty(item.voteResult?.trim()) || item.voteResult === '请选择') {
              this.Info(h_i18n('09334806287d60f5b2bb2a3719f30fa8'), j + 1, h_i18n('b5bbdad51869da73342703720c9657a7'), false, h_i18n('d5b1d036097aeb26456527e4bc06f76e'));
              return;
            }
          } else {

            let ll = Object.keys({ ...mapping, voteResult: '单项判定' });

            for (const itm of ll) {

              //判断空
              if (this.IsEmpty(item[itm]?.trim())) {
                this.Info(h_i18n('09334806287d60f5b2bb2a3719f30fa8'), j + 1, mapping[itm], false, h_i18n('ee68958200b067557acc666757b4bcaa'));
                return;
              }

              //判断值合法
              if (itm === 'sampleNum' || itm === 'ac' || itm === 're') {
                if (item[itm] !== '/' && !reg.test(item[itm]?.trim())) {
                  this.Info(h_i18n('09334806287d60f5b2bb2a3719f30fa8'), j + 1, mapping[itm], false, h_i18n('0c7dc68e9723fc908ac3c687f7623863'));
                  return;
                }
              }

              //判断实测值合法
              if (itm === 'measured') {
                if (text_reg.test(item[itm]?.trim())) {
                  this.Info(h_i18n('09334806287d60f5b2bb2a3719f30fa8'), j + 1, mapping[itm], false, h_i18n('6a43db412156e4d1185e387343460170'));
                  return;
                }
              }
            }

            if (item.voteResult === '请选择') {
              this.Info(h_i18n('09334806287d60f5b2bb2a3719f30fa8'), j + 1, h_i18n('4158228943415a8cc85084d68ef18802'), false, h_i18n('d5b1d036097aeb26456527e4bc06f76e'));
              return;
            }
            // this.info(`${h_i18n('743c292b4cd3997c2b4414c45c1f0525')}${j + 1}${h_i18n('55eac29b1515b574cf383ba69c7dda0e')}`, h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), {
            //   confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            // });
            // return;
          }
          if (item.voteResult == "不合格") {
            haseNoVoteResult = true;
          }
        }
      }

      // supplyBacth 供应商生产批次号  bacthLine 本批生产线体 bacthProductDate 本批生产日期 shiftProduct 本批生产班次
      // factoryAddress 生产公司地址 bacthNum 本批生产数量 authName 认证名称 authNo 认证号 authDate 有效期 rohsNo 宣告表号
      // rohsDate 有效期  checkEmpName 检验人  checkDate 检验时间 checkResult 供应商判定 是否合格
      let infoData = {
        supplyBacth: h_i18n('ab9171823cf0ff877181376ae3cefe11'),
        bacthLine: h_i18n('4b2f8dbe99855fdbcae45945efe19c82'),
        bacthProductDate: h_i18n('45874c85767113619ab5e110b87c69ab'),
        shiftProduct: h_i18n('659d36500f21014ae4360729013f1fcc'),
        factoryAddress: h_i18n('4bc70779dfcf23aefffe0e4175e410fb'),
        bacthNum: h_i18n('4088b9452f5cc640696039f845b2b2a1'),

        checkEmpName: h_i18n('103d893628df5fb82c0dcc09899bf9d7'),
        checkDate: h_i18n('1a58c1628876174eab86bc1547134164'),
        checkResult: h_i18n('487bb72f29181cf97d58155646ef0b5e'),
      };
      let requierMaterData = [];
      if (this.statusOfdelete == "N") {
        //必须截图
        requierMaterData = [
          "supplyBacth",
          "bacthLine",
          "bacthProductDate",
          "shiftProduct",
          "bacthNum",
          "checkEmpName",
          "checkDate",
          "checkResult",
        ];
      } else if (this.statusOfdelete == "Y") {
        // 2023年1月11日 修改非必须截图 时公司地址的校验
        this.materData.factoryAddress = this.factoryAddressNew;
        console.log("this.materData.factoryAddressNew", this.factoryAddressNew);
        // this.materData.factoryAddress = this.materData.factoryAddressNew
        requierMaterData = [
          "supplyBacth",
          "bacthLine",
          "bacthProductDate",
          "shiftProduct",
          "factoryAddress",
          "bacthNum",
          "checkEmpName",
          "checkDate",
          "checkResult",
        ];
      } else {
        requierMaterData = [
          "supplyBacth",
          "bacthLine",
          "bacthProductDate",
          "shiftProduct",
          "factoryAddress",
          "bacthNum",
          "checkEmpName",
          "checkDate",
          "checkResult",
        ];
      }
      let materDataParams = { ...this.materData };
      for (let k = 0; k < requierMaterData.length; k++) {
        if (!materDataParams[requierMaterData[k]]) {
          this.info(`${infoData[requierMaterData[k]]}${h_i18n('5c6881399f5d240f24a5555eb85f4389')}`, h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), {
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          });
          return;
        }
      }
      if (haseNoVoteResult && materDataParams.checkResult == "合格") {
        this.info(`${h_i18n('f7b7e20f52dae5c4cb5a8c1f2252731c')}`, h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), {
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        });
        return;
      }

      // materData.checkResult
      if (materDataParams.checkDate) {
        materDataParams.checkDate = moment(materDataParams.checkDate).format(
          "YYYY-MM-DD"
        );
      }
      if (materDataParams.rohsDate) {
        materDataParams.rohsDate = moment(materDataParams.rohsDate).format("YYYY-MM-DD");
      }
      if (materDataParams.authDate) {
        if (materDataParams.authDate == "/") {
          materDataParams.authDate = "";
        } else {
          materDataParams.authDate = moment(materDataParams.authDate).format(
            "YYYY-MM-DD"
          );
        }
      }
      if (materDataParams.bacthProductDate) {
        materDataParams.bacthProductDate = moment(
          materDataParams.bacthProductDate
        ).format("YYYY-MM-DD");
      }
      //checkDate rohsDate authDate bacthProductDate
      let paramsData = [];

      if (this.list !== undefined && this.list.length > 0) {
        this.list.forEach((item) => {
          item.itemList.forEach((child) => {
            paramsData.push({
              ...child,
              templateId: item.templateId,
              templateType: item.templateType,
            });
          });
        });
      }

      this.commentList[0].itemList.forEach((item) =>
        paramsData.push({
          ...item,
          templateId: "",
          templateType: "A",
        })
      );
      //----
      // let commonList = []
      // if (this.list !== undefined && this.list.length > 0) {
      //   this.list.forEach(item => {
      //     item.itemList.forEach(child => {
      //       commonList.push({ ...child, templateId: item.templateId, templateType: item.templateType })
      //     })
      //   })
      // }
      // this.commentList[0].itemList.forEach(item => commonList.push({
      //   ...item,
      //   templateId: "",
      //   templateType: "A"
      // })
      // )
      // console.log(paramsData,materDataParams,'调用提交')
      //----
      // 如果图片状态为必填 - 需要改为statusOfdelete字段判断必须截图才校验图片
      if (this.statusOfdelete == "N") {
        console.log(! this.materData.samplePhotoUuid);
        console.log(! this.materData.inspectionPocessPhotoUuid);
        console.log(! this.materData.factoryAddressNewId);
        console.log(
          this.materData.samplePhotoUuid ,
          this.materData.inspectionPocessPhotoUuid ,
          this.materData.factoryAddressNewId,
          this.materData
        );
        if (
          ! this.materData.samplePhotoUuid ||
          ! this.materData.inspectionPocessPhotoUuid ||
          ! this.materData.factoryAddressNewId
        ) {
          this.info(h_i18n('90d5b37f2b6ac7b45f2accf8fe696708'));
          return;
        }
      }
      materDataParams.samplePhoto = this.samplePhoto;
      // materDataParams.inspectionPocessPhotoUuid = this.inspectionPocessPhotoUuid
      materDataParams.inspectionPocessPhoto = this.inspectionPocessPhoto;
      materDataParams.factoryAddressNew = this.factoryAddressNew;
      materDataParams.uploadSamplePhotoTime = this.uploadSamplePhotoTime;
      materDataParams.uploadInspectionPocessPhotoTime = this.uploadInspectionPocessPhotoTime;
      materDataParams.factoryAddressNewId = this.factoryAddressNewId;
      materDataParams.reportId = this.saveTempId ? this.saveTempId : undefined;
      if (this.samplePhotoUuid) {
        materDataParams.samplePhotoUuid = this.samplePhotoUuid.data;
      }
      if (this.inspectionPocessPhotoUuid) {
        materDataParams.inspectionPocessPhotoUuid = this.inspectionPocessPhotoUuid.data;
      }
      if(this.$route.query.mtlName){
        materDataParams.mtlName = this.$route.query.mtlName
      }
      this.loading = true;
      this.$http({
        method: "post",
        // url: '/unload/reports/item/add',
        url: "/base/baseShipmentReport/addReportItem",
        // headers: { 'content-type': 'application/x-www-form-urlencoded' },
        data: {
          // paramsData
          ...materDataParams,
          commonList: paramsData,
        },
      })
        .then((res) => {
          console.log(res, "新增------10");
          this.loading = false;
          if (res.data.success) {
            if(this.flag == 'add'){
              // this.success("新增成功");
              this.success(h_i18n('a5bfd70d4ab989bd6abd3ac7a9d11743'), {
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              callback: (action) => {
                // window.history.go(-1)
              },
            });
            }else{
              // this.success('修改成功')
              this.success(h_i18n('69be671786f62ce872f87de1ab761746'), {
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              callback: (action) => {
                // window.history.go(-1)
              },
            });
            }
            this.$router.back();
          }else {
            this.info( res.data.msg || h_i18n('5badb3ba850fe144904d1bf6375fbd92'), {
              confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
              callback: (action) => {
              }
            })
          }
        })
        .catch((err) => {
          this.info(err.message);
        });
    },
    audit(flag) {
      if (
        this.audittextarea == "" ||
        this.audittextarea == null ||
        this.audittextarea == undefined
      ) {
        this.info(h_i18n('a6d0cdccce2eb8f501ef0b290fde3fe2'));
        return false;
      }
      this.loading = true;
      this.$http({
        method: "post",
        // url: '/unload/reports/item/audit',
        url: "/base/baseShipmentReport/audit",
        data: {
          reportId: this.$route.query.reportId,
          status: flag,
          name: this.$route.query.name,
          nickName: this.$route.query.nickName,
          auditOpinion: this.audittextarea,
        },
      }).then((res) => {
        console.log("审核11", res);
        this.loading = false;
        if (res.data.success) {
          this.success({
            message: h_i18n('23b62e9cbc868e024b80d2e3fad80ac7'),
            title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
            confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
            // cancelButtonText:"关闭",
            callback: (action) => {
              if (action === "confirm") {
                this.$router.back();
              }
            },
          });
        }
      });
    },
    searchByValueTypeId(id) {
      this.$http({
        method: "get",
        url: "/base/basicData/listBaseValues?valueTypeId=" + id,
      }).then((res) => {
        if (id == 13) {
          this.importancePropertyList = res.data.data;
        }
        if (id == 14) {
          this.checkLevelList = res.data.data;
        }
      });
    },
    getAddressList(supplyCode) {
      this.$http({
        method: "get",
        url: "/base/baseShipmentReport/addressList",
        params: {
          supplyCode,
        },
      })
        .then((res) => {
          console.log(res, "13-13_new");
          if (res.data.success) {
            if (res.data.data && res.data.data.length) {
              // this.manualVisible = true;
              this.supplyCodeList = res.data.data;
              // this[listKey] = res.data.data
            }
          }
        })
        .catch((err) => {
          this.info(err.message);
        });
    },
    // 监听页面刷新方法
    ListenerFun(event) {
      // Cancel the event as stated by the standard.
      event.preventDefault();
      // Chrome requires returnValue to be set.
      event.returnValue = "";
    },
    // 监听鼠标方法
    mouseFun(event) {
      let x1 = event.clientX;
      let y1 = event.clientY;
      if (this.x !== x1 || this.y !== y1) {
        this.timerOf300000 = 0;
        // console.log(x1,y1)
      }
      this.x = x1;
      this.y = y1;
    },
    getReportById(reportId) {
      this.$http({
        method: "get",
        // url: '/unload/reports/item',
        url: "/base/baseShipmentReport/reportsItem",
        // headers: { 'content-type': 'application/x-www-form-urlencoded' },
        params: { reportId },
      }).then((res) => {
        console.log(res, "14-14");
        if (res.data.success) {
          this.exportdata = res.data.data;
          this.materData = {
            ...res.data.data,
          };
          // console.log(this.materData)
          this.list = res.data.data.itemList;
          this.commentList[0].itemList = res.data.data.commonList;
          this.audittextarea = res.data.data.auditOpinion;
          if (
            res.data.data.authDate == undefined ||
            res.data.data.authDate == null ||
            res.data.data.authDate == ""
          ) {
            this.materData.authDate = "/";
          } else {
            this.materData.authDate = moment(res.data.data.authDate).format("YYYY-MM-DD");
          }
          this.getDeleteStatusBySupplyCode();
          this.getRohs();
        }
      });
    },
    keydownFun(event) {
      this.timerOf300000 = 0;
      // console.log(event)
    },
    scrollFun(event) {
      this.timerOf300000 = 0;
      // console.log(event)
    },
    // 10分钟暂存
    saveTempOfTen() {
      this.timer10M = setInterval(() => {
        if (this.timerOf600000 >= 600) {
          //600S
          this.saveTempAuto();
          // console.log('10分钟的暂存')
          this.timerOf600000 = 0;
          clearInterval(this.timer10M);
          this.saveTempOfTen();
        }
        this.timerOf600000++;
        // console.log(this.timerOf600000)
      }, 1000);
    },
    // 5分钟呗
    saveTempOfFive() {
      this.timer5M = setInterval(() => {
        if (this.timerOf300000 >= 300) {
          //300S
          this.saveTempAuto();
          // console.log('5分钟的暂存')
          this.timerOf300000 = 0;
          clearInterval(this.timer5M);
          this.saveTempOfFive();
        }
        this.timerOf300000++;
        // console.log(this.timerOf300000)
      }, 1000);
    },
    changeFun(e) {
      if (e) {
        this.isChangeFlag = true;
        console.log('----------->,',this.list)
        // console.log(this.isChangeFlag )
      }
    },
    // inputFun(e){
    //   console.log(e)
    // },
  },

  beforeUnmount() {
    window.removeEventListener("beforeunload", this.ListenerFun);
    window.removeEventListener("mousemove", this.mouseFun);
    window.removeEventListener("keydown", this.keydownFun);
    window.removeEventListener("scroll", this.scrollFun);
    window.removeEventListener("change", this.changeFun);
    // window.removeEventListener('input' ,this.inputFun)
    clearInterval(this.timer10M);
    clearInterval(this.timer5M);
  },
  mounted() {
    // window.addEventListener('input',this.inputFun)
    if (this.$route.query) {
      if (this.$route.query.dataFrom) {
        this.dataFrom = this.$route.query.dataFrom;
      }
      // console.log(this.$route.query)
      if (this.$route.query.supplyCode) {
        this.supplyCode = this.$route.query.supplyCode;
        this.getAddressList(this.supplyCode);
      }
      if (this.$route.query.name) {
        // localStorage.setItem("name",this.$route.query.name);
        // localStorage.setItem("nickName",this.$route.query.nickName)
        window.getItemName = this.$route.query.name;
        window.getItemNickName = this.$route.query.nickName;
      }
      //versionNo:rows.versionNo,
      //  mtlNo:rows.mtlNo,
      if (this.$route.query.reportId) {
        this.getReportById(this.$route.query.reportId);
        this.saveTempId = this.$route.query.reportId;
      } else {
        this.getMatName(this.$route.query.mtlNo);
        this.getTemplateList(this.$route.query.mtlNo);
        this.getCommonTemplateList(this.$route.query.mtlNo);
      }
      if (this.$route.query.flag) {
        if (this.$route.query.flag != "edit" && this.$route.query.flag != "add") {
          this.editFalg = true;
          this.haseRead = true;
        }
        if (this.$route.query.flag == "add") {
          this.supplyCode = this.$route.query.supplyCode;
          this.getDeleteStatusBySupplyCode();
        }
        this.flag = this.$route.query.flag;
      }
      if (this.$route.query.factoryAddressNew) {
        this.factoryAddressFromQuery = this.$route.query.factoryAddressNew;
        // console.log(this.factoryAddressFromQuery)
      }
      this.loading = false;
    }
    // 修改和新增时添加监听
    if (this.$route.query.flag == "edit" || this.$route.query.flag == "add") {
      this.saveTempFlag = true;
      // console.log('修改页或新增页')
      // 离开页面提示
      window.addEventListener("beforeunload", this.ListenerFun);
      // 监听鼠标事件
      window.addEventListener("mousemove", this.mouseFun);
      // 监听键盘事件
      window.addEventListener("keydown", this.keydownFun);
      // 监听滚轮事件
      window.addEventListener("scroll", this.scrollFun);
      // 监听change事件
      window.addEventListener("change", this.changeFun);
      // 开启暂存
      this.saveTempOfTen();
      this.saveTempOfFive();
    }
    this.searchByValueTypeId(13);
    this.searchByValueTypeId(14);
    this.changeHeight();

    for (let i = 1; i < 10; i++) {
      setTimeout(() => {
        this.postThisPageHeightMore();
      }, i * 100);
    }
    // 改textarea 90px的固定值， 可以拉伸
    document.querySelector('.el-textarea__inner').style.height = 'auto'
  },
  unmounted() {
    // console.log('销毁中---')
    if (this.player) {
      this.player.stop();
      // console.log('关闭萤石组件')
    }
  },
};
</script>

<style lang="scss">
.el-input__inner{
    color: #1D2129 !important;
}
.haier-td {
    color: #1D2129 !important;
}
.el-textarea__inner{
  color: #1D2129 !important;
}
.config-provide {
  background: #f2f4f7 !important;
  margin: 0 !important;
}

html,
body {
  overflow-y: auto !important;
  // // width: 95%;
  // overflow-x: hidden;
  .el-textarea__inner{
    // height: 30px !important;
  }
}
.h-upload-template-upload {
  display: none !important;
}
.shipmentReport {
  width: 100%;
  background: #f2f4f7;
  font-size: 14px;

  .fac_flex {
    display: flex;
  }
  .fac_line {
    line-height: 40px;
  }
  .tabbar {
    width: 100%;
    height: 46px;
    background: #fff;
    margin-bottom: 8px;
    line-height: 46px;
    position: absolute;
    top: 0;
    z-index: 9999;
    border-bottom: 1px solid #f2f4f7;

    .add_title {
      font-weight: 400;
      color: #1d2129;
      font-size: 16px;
      margin-right: 16px;
      float: left;
    }

    .add_import_title {
      color: #86909c;
      font-size: 14px;
      float: left;
    }
   
    .btn_gro {
      float: right;
      display: flex;
      margin-right: 16px;
      margin-top: 6px;

      .item_btn {
        width: 80px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
        color: #1d2129;
        border-radius: 8px;
        margin-left: 12px;
        border: 1px solid #E5E6EB;
        cursor: pointer;
      }
    }
  }
  .footerBut{
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 20px;
  }
  .fac_nav {
    padding: 16px 16px 8px 16px;
    background-color: #fff;
    margin: 0 16px 12px 16px;
    border-radius: 8px;
    margin-top: 58px;

    .fac_bg {
      justify-content: space-between;
      background-color: #f1f2f8;
      border-radius: 8px;
      height: 56px;
      padding: 0 16px;
      line-height: 56px;
      font-size: 14px;
      color: #1d2129;
      align-items: center;

      .nav_title {
        font-size: 24px;
      }

      img {
        width: 91px;
        height: 34px;
      }
    }

    .fac_mes {
      height: 40px;
      line-height: 40px;
      justify-content: space-between;
    }
  }

  .fac_inp {
    padding: 16px;
    height: 174px;
    margin: 0 16px 12px 16px;
    background-color: #fff;
    border-radius: 8px;

    .fac_inp_title {
      color: #1d2129;
      font-weight: 600;
    }

    .fac_33 {
      width: 33%;
      line-height: 34px;
    }
  }

  .fac_photo {
    padding: 16px;
    height: auto;
    margin: 0 16px 12px 16px;
    background-color: #fff;
    border-radius: 8px;
  }

  .fac_table_wrap{
    padding: 16px;
    margin: 0 16px;
    background-color: #fff;
    border-radius: 8px;
  }
  .fac_table {
   
    height: auto;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #E5E6EB;
    .el-input__inner {
      width: 95% !important;
    }
    .el-date-editor--date{
      .el-input__inner {
      width: 100% !important;
    }
    }
    .fac_table_nav {
      height: 44px;
      font-size: 14px;
      text-align: left;
      line-height: 44px;
      border-bottom: 1px solid #E5E6EB;
      padding: 0 16px;
    }

    .fac_tr {
      display: flex;
      // height: 44px;
      font-size: 14px;
      text-align: left;
      // line-height: 44px;
      min-height: 44px;
      line-height: 22px;
      border-bottom: 1px solid #E5E6EB;
      padding: 0 16px;
    }

    .fac_table_50 {
      width: 50px;
      margin: auto;
    }

    .fac_table_100 {
      width: 100px;
      margin: auto;
    }

    .fac_table_150 {
      width: 150px;
      margin: auto;
    }
    .fac_table_200 {
      width: 200px;
      margin: auto;
    }
    .fac_table_300 {
      width: 300px;
      margin: auto;
      padding: 5px;
      word-wrap: break-word;
    }
    .fac_table_max {
      width: calc(100% - 1100px);
      min-width: 150px;
      margin: auto;
      text-align: left;
      padding: 5px;
      
    }
    .fac_table_max2 {
      width: calc(100% - 900px);
      margin: auto;
      text-align: left;
      padding: 5px;
      
    }
    .fac_center {
      text-align: center;
    }

    .fac_table_hidden {
      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
      margin: auto;
    }
    .marginAuto{
      margin: auto;
    }
  }
}
.blueClick {
  color: #165dff;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  &:hover {
    color: #4080ff;
  }
  &:active {
    color: #0e42d2;
  }
}
.tipBox_yellow {
    padding: 2px 16px;
    border: 1px solid #ffe4ba;
    background-color: #fff7e8;
    border-radius: 6px;
    line-height: 18px;
    height: auto;
    color: #1D2129;
    font-size: 14px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    margin:4px 8px 0 0;

    img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }
</style>